/* src/app/private/components/leads/bulk-move-to-registration/bulk-move-to-registration.component.scss */
/*# sourceMappingURL=bulk-move-to-registration.component.css.map */
